import { alpha, styled } from '@mui/material';
import { common } from '@mui/material/colors';

export const BackdropLoaderRoot = styled('div')(({ isPlane }: { isPlane?: boolean }) => ({
  position: 'absolute',
  zIndex: 1010,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  backgroundColor: alpha(common.white, isPlane ? 1 : 0.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
